import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, LOCALE_ID } from '@angular/core';
import { saveAs } from 'file-saver-es';
import { stringify } from 'qs';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AtomParams } from './atom.service';

export type SaveAsFunction = (data: Blob | string, filename?: string) => void;

export type ExportParams = Pick<AtomParams, 'filter' | 'direction' | 'sort'>;

export const SAVE_AS = new InjectionToken<SaveAsFunction>(
  'File saver save as function',
  {
    providedIn: 'root',
    factory: () => (data: Blob | string, filename?: string) =>
      saveAs(data, filename),
  }
);

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor(
    private http: HttpClient,
    @Inject(SAVE_AS) private readonly saveFile: SaveAsFunction,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  excel(
    type: string,
    { direction, filter, sort }: ExportParams = {}
  ): Observable<Blob> {
    return this.http
      .get(`${environment.api}/${type}/list/export`, {
        responseType: 'blob',
        params: new HttpParams({
          fromString: stringify({
            langs: this.locale,
            filter,
            sort: sort && {
              [this.locale]: direction === 'desc' ? `-${sort}` : sort,
            },
          }),
        }),
      })
      .pipe(
        tap((data) => {
          const now = new Date().toISOString();
          const name = type.toLowerCase();
          this.saveFile(data, `${name}.${now}.xlsx`);
        })
      );
  }
}
